import React, { useState } from 'react';
import CustomSwitch from '../../../../../shared/CustomSwitch/CustomSwitch';

const invoiceData = [
  {
    label: 'Total due',
    amount: -5679.0,
    currency: 'USD',
    type: 'balance',
    bgColor: 'rgb(241, 250, 243)',
    borderColor: 'rgb(173, 225, 187)',
  },
  {
    label: 'Recent adjustments',
    amount: 0.0,
    currency: 'USD',
    type: 'adjustment',
    bgColor: 'rgb(242, 230, 243)',
    borderColor: 'rgb(217, 217, 217)',
  },
  {
    label: 'Recent payments',
    amount: 5804.83,
    currency: 'USD',
    type: 'payment',
    bgColor: 'rgb(211, 246, 252)',
    borderColor: 'rgb(176, 225, 233)',
  },
  {
    label: 'Last invoice amount',
    amount: 125.83,
    currency: 'USD',
    type: 'invoice',
    bgColor: 'rgb(240, 244, 249)',
    borderColor: 'rgb(211, 227, 253)',
  },
];

export default function DueSummary({ checked, onChange, hidden }) {
  return (
    <div
      className={`sub-card ${hidden ? 'card-disabled' : ''}`}
      id="due-summary"
    >
      <div className="garden-wall-card-header">
        <h4 className="card-title">Total due summary</h4>
        <CustomSwitch
          checked={checked} // from parent
          onChange={onChange} // from parent
          size="small" // small | medium | large
          color="var(--primary-color)"
        />
      </div>
      <div className="due-summary-cards">
        {invoiceData.map((item) => (
          <div
            key={item.type} // ✅ unique key added
            className="due-summary-card"
            style={{
              background: item.bgColor,
              border: `1px solid ${item.borderColor}`, // fixed: was `item.border`
            }}
          >
            <h5 className="due-summary-label">{item.label}</h5>
            <p className="due-summary-value">{item.amount}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
